import { I18nContext, useI18nState } from "@/i18n";
import { HeroSection } from "@/components/HeroSection";
import { Timeline } from "@/components/Timeline";
import { CtaBar } from "@/components/CtaBar";
import { ClosureBanner } from "@/components/ClosureBanner";
import { Footer } from "@/components/Footer";

export default function App() {
  const i18n = useI18nState();

  return (
    <I18nContext.Provider value={i18n}>
      <div className="min-h-screen bg-surface-0">
        <ClosureBanner />
        <HeroSection />
        <Timeline />
        <Footer />
        <CtaBar />
      </div>
    </I18nContext.Provider>
  );
}
